module.exports = __webpack_public_path__ + "static/media/SNoor.b2cb0bcd.png";